import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

const BrandsCarousel = () => {
  const brands = [
    {
      name: 'Castler',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/if3jboia_Castler.png',
    },
    {
      name: 'Aakash Education',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/7fhlxvn6_Aakash-removebg-preview.png',
    },
    {
      name: 'IndiaMART',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/gjd9756s_IndiaMART.png',
    },
    {
      name: 'HT Media',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/cpe8ovpw_HT.png',
    },
    {
      name: 'Mint',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/9ofd1jbh_mint.png',
    },
    {
      name: 'Satvic Movement',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/fmzl4qi3_SM.png',
    },
    {
      name: 'Dabur',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/iogxms4u_Dabur.png',
    },
    {
      name: 'Axis Bank',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Axis_Bank_logo.svg',
    },
    {
      name: 'Publicis Groupe',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/rojiyfjr_PG.png',
    },
    {
      name: 'Heinz India',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/k4k18gvo_Heinz_logo.svg.png',
    },
    {
      name: 'WAE',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/6au662g7_images__2___1_-removebg-preview.png',
    },
    {
      name: 'Atdoorstep',
      logo: 'https://customer-assets.emergentagent.com/job_web-profile-19/artifacts/b82vwwae_Screenshot_2026-01-03_at_9.56.07_PM-removebg-preview.png',
    },
  ];

  const plugin = React.useRef(
    Autoplay({ delay: 2500, stopOnInteraction: true })
  );

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Brands That Trusted Me With Their Growth</h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            From billion-dollar enterprises to mission-driven startups. From fintech platforms redefining 
            trust to education giants shaping futures. Each brand taught me something different about what 
            makes marketing work.
          </p>
        </div>

        <div className="hidden md:block">
          <Carousel
            plugins={[plugin.current]}
            className="w-full"
            onMouseEnter={plugin.current.stop}
            onMouseLeave={plugin.current.reset}
            opts={{
              align: 'start',
              loop: true,
            }}
          >
            <CarouselContent className="-ml-4">
              {brands.map((brand, index) => (
                <CarouselItem key={index} className="pl-4 md:basis-1/3 lg:basis-1/5">
                  <div className="p-6 h-28 flex items-center justify-center bg-white hover:bg-slate-50 transition-colors rounded-lg border border-slate-200 shadow-sm">
                    <img
                      src={brand.logo}
                      alt={`${brand.name} logo`}
                      className="max-w-full max-h-20 object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="hidden w-full h-full items-center justify-center">
                      <span className="text-sm font-semibold text-slate-700">{brand.name}</span>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden lg:flex" />
            <CarouselNext className="hidden lg:flex" />
          </Carousel>
        </div>

        {/* Mobile Grid */}
        <div className="md:hidden grid grid-cols-2 gap-4">
          {brands.map((brand, index) => (
            <div key={index} className="p-4 h-24 flex items-center justify-center bg-white border border-slate-200 rounded-lg shadow-sm">
              <img
                src={brand.logo}
                alt={`${brand.name} logo`}
                className="max-w-full max-h-16 object-contain filter grayscale"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden w-full h-full items-center justify-center">
                <span className="text-xs font-semibold text-slate-700">{brand.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;